import { useRef } from 'react'
import { ProductFruits as ProductFruitsComponent } from 'react-product-fruits'

import { EMPTY_STRING } from '../../../constants/common'
import { useLayoutOverlayContext, useUserData } from '../../../hooks'
import { MinimizedModals } from '../../MinimizedModals'

import {
  LAUNCHER_ROW_ATTRIBUTE,
  PRODUCT_FRUITS_WORKSPACE_CODE,
} from './LayoutOverlay.constants'
import {
  useLauncherRowWidth,
  useProductFruitsCustomLauncher,
} from './LayoutOverlay.hooks'
import { getProductFruitsUserInfo } from './LayoutOverlay.utils'
import { LayoutOverlayGretaAIChat } from './LayoutOverlayGretaAIChat'
import { SupportLauncherButton } from './SupportLauncherButton'

import * as styles from './LayoutOverlay.module.css'

function LayoutOverlay() {
  const user = useUserData()

  const { showGretaAIChat, showProductFruits } = useLayoutOverlayContext()

  const ukLang = user.language.code

  const supportLauncherRef = useRef(null)
  const actionsRef = useRef(null)

  const hasActions = showProductFruits || showGretaAIChat

  const { isOpen: isSupportOpen, unreadCount } = useProductFruitsCustomLauncher(
    {
      elementRef: supportLauncherRef,
      enabled: showProductFruits,
    }
  )

  useLauncherRowWidth({ enabled: hasActions, ref: actionsRef })

  return (
    <>
      <div
        {...(hasActions ? { [LAUNCHER_ROW_ATTRIBUTE]: EMPTY_STRING } : null)}
        className={styles.actions}
        ref={actionsRef}
      >
        {showProductFruits ? (
          <SupportLauncherButton
            isPressed={isSupportOpen}
            ref={supportLauncherRef}
            unreadCount={unreadCount}
          />
        ) : null}
        {showGretaAIChat ? (
          <LayoutOverlayGretaAIChat displayName={user.fullname} />
        ) : null}
      </div>
      <MinimizedModals />

      {showProductFruits ? (
        <ProductFruitsComponent
          config={{
            hideInAppCenterLauncher: true,
          }}
          language={ukLang}
          user={getProductFruitsUserInfo(user)}
          workspaceCode={PRODUCT_FRUITS_WORKSPACE_CODE}
        />
      ) : null}
    </>
  )
}

export default LayoutOverlay
